import request from "@/utils/request"

export function getpaycode(form) {
  return request.post("/pay/getpaycode", form)
}

export function banklist() {
  return request.post("/pay/banklist")
}

export function recharge(form) {
  return request.post("/pay/recharge", form)
}

/**
 * 在线支付接口,  获得最后的支付跳转连接
 * @param {*} form
 */
export function getpayurl(form) {
  return request.post("/pay/onlinepay", form)
}

export function getNewPayurl(form) {
  return request.post("/pay/newOnlinepay", form)
}

/**
 * 余额支付接口,  获得最后的支付跳转连接
 * @param {*} form
 */
export function getbalancepay(form) {
  return request.post("/pay/balancepay", form)
}
export function getNewBalancepay(form) {
  return request.post("/pay/newBalancepay", form)
}

/**
 * 线下支付接口,  获得最后的支付跳转连接
 * @param {*} form
 */
export function getofflinepay(form) {
  return request.post("/pay/offlinepay", form)
}

export function listinvest(status, pageNo, pageSize) {
  return request.post("/pay/listinvest", {
    status: status,
    pageNo: pageNo,
    pageSize: pageSize,
  })
}

export function investprotocol(investId) {
  return request.post("/pay/investprotocol", { investId: investId })
}
export function investNewprotocol(form) {
  return request.post("/pay/investprotocol", form)
}

export function fundoutclaimer(form) {
  return request.post("/pay/fundoutclaimer", form)
}

/**
 * 支付方式及回款方式线下转账信息
 * @param {*} form
 */
export function paytype(form) {
  return request.post("/pay/paytype", form)
}

/**
 * 获取预计收益
 * @param {+} form={ amount:金额,productId:产品ID }
 * @returns {*}
 */
export function getReturnAmount(form) {
  return request.post("/pay/getReturnAmount", form)
}

//获取可用红包接口
export function getRedPacket(form) {
  return request.post("/pay/getUseRedBag", form)
}

export function getAllRedBag(form) {
  return request.post("/pay/getAllRedBag", form)
}

export function getRedBagList(form) {
  return request.post("/redPacket/selectRedPacketRecordList", form)
}

export function getReadRedBagList(form) {
  return request.post("/redPacket/selectReadyRedPacketRecordList", form)
}

/**
 * 获取我的优惠券数量
 * @returns 
 */
export function getRedPacketRecordNum() {
  return request.post("/redPacket/redPacketRecordNum")
}

export function investDetail(id, status) {
  return request.post("/pay/investDetail", { id, status })
}

export function cancelInvest(investId) {
  return request.post("/pay/cancelInvest", { investId })
}

export function cancelInvestChannel(channel) {
  return request.post("/pay/cancelInvestChannel", { channel })
}

/**
 * 创建订单
 * @param {*} order 
 * @returns 
 */
export function getOrderId(order) {
  return request.post("/pay/getOrderId", order)
}
/**
 * 获取产品签名信息
 * @param {*} order 订单ID
 * @returns 
 */
export function getSignatureUrl(order) {
  return request.post("/pay/signature", order)
}
/**
 * 获取拍卖资产签名信息
 * @param {*} orderId 订单ID
 * @returns 
 */
export function getAuctionSignatureUrl(orderId) {
  return request.post("/auction/signature", { orderId: orderId })
}
export function getSignatureResult(form) {
  return request.post("/pay/getSignatureResult", form)
}

/**
 * 取消订单
 * @returns 
 */
export function cancelOrder() {
  return request.post("/pay/cancelOrder")
}

/**
 * 获取订单信息
 * @param {*} orderId 订单ID
 * @returns 
 */
export function getOrderInfo(orderId) {
  return request.post("/pay/orderInfo", { id: orderId })
}

export function experienceTimeLine(orderId) {
  return request.post("/pay/experience/timeLine", { orderId: orderId })
}

/**
 * 获取预期收益
 * @param {*} params { tradeAmount:购买金额,productId:产品ID,rateCouponAmount:加息券 }
 * @returns 
 */
export function returnAmount(params, productType = 1) {
  return request.post(productType == 2 ? "/pay/currentAuctionAmt" : "/pay/returnAmount", params)
}

